import { getStoredBrokersValue } from "@/lib/brokers/storage";
import { getStoredChartSettingsValue } from "@/lib/chart-settings/storage";
import { getStoredChartIndicatorsValue } from "@/lib/chart-indicators/storage";
import { getStoredDrawingsSize } from "@/lib/chart-drawings/storage";
import { getStoredEconomicCalendarValue } from "@/lib/economic-calendar/storage";
import { getStoredQuotesWatchlistValue } from "@/lib/quotes-watchlist/storage";
import { getStoredSettingsValue } from "../settings/storage";

/**
 * Calculate app cache memory (localStorage modules only).
 */
export function calculateAppCacheMemory(): number {
  if (typeof window === "undefined") return 0;

  return (
    getStoredBrokersValue() +
    getStoredChartSettingsValue() +
    getStoredChartIndicatorsValue() +
    getStoredDrawingsSize() +
    getStoredEconomicCalendarValue() +
    getStoredQuotesWatchlistValue() +
    getStoredSettingsValue()
  );
}

/**
 * @deprecated Use getStorageInventory() for account sizes.
 */
export function calculateTradingAccountMemory(_accountId: string): number {
  return 0;
}

/**
 * @deprecated Use getStorageInventory() for account sizes.
 */
export function calculateTradingAccountServerMemory(_accountId: string): number {
  return 0;
}

/**
 * @deprecated Use getStorageInventory() for server/account market data sizes.
 */
export function calculateServerMemoryByCompanyAndServer(
  _company: string,
  _serverName: string
): number {
  return 0;
}

/**
 * Format bytes to human readable string
 */
export function formatBytes(bytes: number): string {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}
